import { numberFromEnv } from "./lib/helpers";

export const getCheckoutUrl = ({
  zoneId,
  checkoutKey,
  mode: checkoutMode,
  storeKey,
}: {
  zoneId: string;
  checkoutKey: string;
  mode: "sku-in-box" | "autonomous";
  storeKey: string;
}): string =>
  `/stores/${storeKey}/zones/${zoneId}/${checkoutMode}/checkout/${checkoutKey}`;

export const getMainUrl = ({
  zoneId,
  storeKey,
  mode: checkoutMode,
}: {
  zoneId: string;
  storeKey: string;
  mode: "sku-in-box" | "autonomous";
}): string => `/stores/${storeKey}/zones/${zoneId}/${checkoutMode}`;

export const getGuideUrl = ({
  zoneId,
  storeKey,
  mode: checkoutMode,
}: {
  zoneId: string;
  storeKey: string;
  mode: "sku-in-box" | "autonomous";
}): string => `/stores/${storeKey}/zones/${zoneId}/${checkoutMode}/guide`;

export const ERROR_MODAL_AUTO_CLOSE_TIMEOUT = numberFromEnv(
  "VITE_ERROR_AUTO_CLOSE_TIMEOUT",
  10_000,
);
export const SUCCESS_MODAL_AUTO_CLOSE_TIMEOUT = numberFromEnv(
  "VITE_SUCCESS_AUTO_CLOSE_TIMEOUT",
  5_000,
);
